import type * as React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  padding: 48px 32px;
  max-width: 900px;
  margin: auto;
`;

export interface OnPageLoaderContainerProps {
  children: React.ReactNode;
}

export function OnPageLoaderContainer(props: OnPageLoaderContainerProps) {
  return <Container>{props.children}</Container>;
}
